/**
 * Replace default copyright year with the current year
 *
 * Dependencies: jQuery
 */

import $ from "jquery";

export default function() {
  $(function() {
    $(".footer-nav a").each(function(i) {
      $(".siteCopyright")
        .append(" | ")
        .append($(this));
    });
  });
  document.addEventListener("scroll", function() {
    const backToTop = document.querySelector(".back-to-top");
    if (backToTop) {
      if (window.scrollY < 100) {
        backToTop.classList.add("back-to-top--hidden");
      } else {
        backToTop.classList.remove("back-to-top--hidden");
      }
    }
    backToTop.addEventListener("click", function(e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  });
}



// WEBPACK FOOTER //
// ./src/js/partials/footer.js